"use strict";

exports.__esModule = true;
exports.default = void 0;

function onMenuKeyDown(event, events) {
  var down = events.down,
      up = events.up,
      enter = events.enter,
      del = events.del,
      esc = events.esc;

  switch (event.keyCode) {
    // down
    case 40:
      down && down(event);
      event.preventDefault();
      break;
    // up

    case 38:
      up && up(event);
      event.preventDefault();
      break;
    // enter

    case 13:
      enter && enter(event);
      event.preventDefault();
      break;
    // delete

    case 8:
      del && del(event);
      break;
    // esc | tab

    case 27:
    case 9:
      esc && esc(event);
      event.preventDefault();
      break;

    default:
  }
}

var _default = onMenuKeyDown;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/_picker/onMenuKeyDown.js
// module id = 1853
// module chunks = 0